import { Record } from 'immutable';
export default Record({
  userEmail: null,
  userId: null
}, 'WorkflowsUser');